import { jsx as _jsx } from "react/jsx-runtime";
const Warning = ({ className, iconColor = 'currentColor', }) => {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", className: className, children: _jsx("path", { stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4M12 17h.01" }) }));
};
export default Warning;
//# sourceMappingURL=warning.js.map